import React, { useState, useEffect } from "react";

const Services= () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    fetch("/data/services.json") // Ensure this file is inside `public/`
      .then((response) => response.json())
      .then((data) => setServices(data.services))
      .catch((error) => console.error("Error fetching services:", error));
  }, []);

  console.log(services);
  
  console.log("typof", services.map((item)=> item.name));
  

  return (
    <ul className="pl-4 mt-2">
      {services.map((service, index) => (
        <li key={index} className="py-2 border-b border-gray-300">
          {/* Service Name and Image */}
          <div className="flex items-center mb-2">
            <img src={service.image} alt={service.name} className="w-8 h-8 mr-3" />
            <h3 className="text-lg font-semibold">{service.name}</h3>
          </div>

          {/* Service Intro */}
          <p className="text-gray-600 text-sm mb-2">{service.intro}</p>

          {/* Our Offerings */}
          <h4 className="font-semibold text-sm">Our Offerings:</h4>
          <ul className="list-disc pl-5 text-gray-600 text-sm">
            {service.offerings.map((offer, idx) => (
              <li key={idx}>{offer}</li>
            ))}
          </ul>

          {/* Why Choose Us */}
          <h4 className="font-semibold text-sm mt-2">Why Choose Us:</h4>
          <ul className="list-disc pl-5 text-gray-600 text-sm">
            {service.whyChooseUs.map((reason, idx) => (
              <li key={idx}>{reason}</li>
            ))}
          </ul>

          {/* Service Details */}
          <p className="text-gray-700 text-sm mt-2">{service.details}</p>
        </li>
      ))}
    </ul>
  );
};

export default Services;
